/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Relativedayagomany3Inputs */

const en_relativedayagomany3 = /** @type {(inputs: Relativedayagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} days ago`)
};

const pt_relativedayagomany3 = /** @type {(inputs: Relativedayagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.n} dias`)
};

/**
* | output |
* | --- |
* | "{n} days ago" |
*
* @param {Relativedayagomany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativedayagomany3 = /** @type {((inputs: Relativedayagomany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativedayagomany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativedayagomany3(inputs)
	return pt_relativedayagomany3(inputs)
});
export { relativedayagomany3 as "relativeDayAgoMany" }